import type { BlogHeading } from "@/lib/blog";

/** Render the TOC only when a post is long enough for navigation to earn its keep. */
export const shouldShowToc = (headings: BlogHeading[]): boolean => headings.length >= 4;

const TocLinks = ({ headings }: { headings: BlogHeading[] }) => (
  <ol className="m-0 flex list-none flex-col gap-1 p-0">
    {headings.map(heading => (
      <li key={heading.id} className="m-0 p-0">
        <a
          href={`#${heading.id}`}
          className="block py-1 text-sm leading-snug text-foreground/60 transition-colors hover:text-brand-600"
        >
          {heading.text}
        </a>
      </li>
    ))}
  </ol>
);

/**
 * Sticky right-rail table of contents for wide viewports. Plain anchor jumps —
 * no scroll spy, no smooth-scroll dependency (must behave with Reduce Motion).
 */
export const BlogTocRail = ({ headings }: { headings: BlogHeading[] }) => (
  <aside className="hidden xl:block">
    <nav aria-label="In this guide" className="sticky top-24 border-l border-foreground/10 pl-5">
      <p className="m-0 mb-2 text-xs font-semibold uppercase tracking-wide text-foreground/50">In this guide</p>
      <TocLinks headings={headings} />
    </nav>
  </aside>
);

/** Collapsed TOC box shown under the post header on narrow viewports. */
export const BlogTocInline = ({ headings }: { headings: BlogHeading[] }) => (
  <details className="rounded-lg border border-foreground/10 bg-foreground/[0.02] px-4 py-3 xl:hidden">
    <summary className="cursor-pointer select-none text-sm font-semibold text-foreground">In this guide</summary>
    <div className="pt-2">
      <TocLinks headings={headings} />
    </div>
  </details>
);
